import moment, { Duration } from "moment";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { getTheme } from "Theme";
const theme = getTheme();

const Main = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 20px;
  align-items: center;
`;

const TimerRow = styled.div`
  display: flex;
  flex-direction: row;
`;

const TimeDescriptionRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 40px;
  padding-left: 60px;
  margin-top: 10px;
`;

const TimeLabel = styled.span`
  font-size: 18px;
  font-weight: 700;
  margin-right: 8px;
  font-size: 18px;
  color: ${theme.MAIN_COLOR};
`;

const Time = styled.span`
  font-size: 48px;
  font-weight: 800;
`;

const Client = styled.span`
  font-size: 16px;
  border: 2px solid ${theme.MAIN_COLOR};
  color: ${theme.MAIN_COLOR};
  border-radius: 4px;
  padding: 5px 10px 5px 10px;
  max-width: 80%;
  margin-top: 20px;
  font-weight: 700;
`;

interface Props {
  start: Date;
  timezone: string;
  clientName?: string;
  positionName?: string;
}

const Timer = ({ start, timezone, clientName, positionName }: Props) => {
  const [duration, setDuration] = useState<Duration>(moment.duration(0));

  useEffect(() => {
    setTimeout(
      () =>
        setDuration(
          moment.duration(moment.tz(timezone).diff(moment.tz(start, timezone)))
        ),
      1000
    );
  }, [duration]);

  return (
    <Main>
      <TimerRow>
        <Time>
          {duration
            ? moment.utc(duration.asMilliseconds()).format("HH : mm : ss")
            : "-- : -- : --"}
        </Time>
      </TimerRow>
      <TimeDescriptionRow>
        <TimeLabel>hrs</TimeLabel>
        <TimeLabel>mins</TimeLabel>
        <TimeLabel>secs</TimeLabel>
      </TimeDescriptionRow>
      {clientName && (
        <Client>
          {clientName} ({positionName})
        </Client>
      )}
    </Main>
  );
};
export default Timer;
